import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <div className='footer'>
      <div className='footer-content'>
       <h3>جميع الحقوق محفوظة لأهالي قرية <span>الشوبك الغربي</span> </h3>
      {/*<div className='info'> 
        <div className='back'>
        <h4>  Hussein Sabry</h4>
        <p>
          : Email{' '}<br/>
          <a href="mailto:sabryhusseinhussein@gmail.com">
            sabryhusseinhussein@gmail.com
          </a>
        </p>
        <p> Phone: 01096586823</p>
        <p>   Backend Developer & Tester </p>
        </div>
     <div className='design'>
<h4>Reda Abdelwahed</h4>    
<p>
:Email{' '}<br/>
    <a href="mailto:redajavascript@gmail.com">reda@gmial.com</a>
</p>
   <p> Phone: +02 1044188791</p>
   <p>UI Designer</p>
        <p>FrontEnd Developer</p>
     </div>
       <div className='front'>
       <h4>Gehad Mohamed</h4>
       <p>
           :Email{' '}<br/>
          <a href="mailto:gehadmo157@gmail.com">
         gehadmo157@gmail.com          </a>
        </p>
        <p>FrontEnd Developer</p>
       </div>
       
      </div>   */}
      <div className="info">
        <p>
          <a href="/contact">تواصل معنا</a>
        </p>
      </div>
      <div className="info">
        <p>
          <a href="https://www.facebook.com/mashhour.azzam.9">إدارة المقابر</a>
        </p>
      </div>
      </div>
    </div>
  );
}
